module.exports = __webpack_public_path__ + "img/circle-arrow-down-left.7ba70d68.svg";